import { useQuery } from '@apollo/client/react';

import { PricingSetDocument } from '@graphql/platform';

import { WT_VISITOR_TOKEN } from '@root/initializers/wt';

const usePricingSetForZIPQuery = (zip: string | undefined) =>
  useQuery(PricingSetDocument, {
    variables: {
      zip: zip!,
      visitorToken: WT_VISITOR_TOKEN,
    },
    skip: !zip || zip.length < 5,
    ssr: false,
  });

export const usePricingSetForZIP = (zip: string | undefined) =>
  usePricingSetForZIPQuery(zip).data?.pricingSet;
